import { useDisclosure } from '@chakra-ui/react';
import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import { getAppTheme, userIsSubscriber } from 'components/Utils/theme';
import { useContext, useEffect, useState } from 'react';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;
const useModelButtonTelemedicina = () => {
  const { user } = useContext(AccountContext);
  const theme = getAppTheme(userIsSubscriber(user));
  const modalTelemedicinaHome = useDisclosure();
  const [hiddenButton, setHiddenButton] = useState(true);
  const [cacheAgendamento, setCachesAgendamentos] = useState([]);

  async function validaFilaAtendimento() {
    await api(`${ENDPOINT}/cache/telemedicine`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(async (res) => {
        return res.json();
      })
      .then(async (resposta) => {
        if (resposta.length > 0) {
          setCachesAgendamentos(resposta);
          setHiddenButton(false);
        } else {
          setHiddenButton(true);
          setCachesAgendamentos([]);
        }
      });
  }

  useEffect(() => {
    validaFilaAtendimento();
    const timeout = setInterval(() => {
      validaFilaAtendimento();
    }, 30 * 1000);
    return () => {
      if (timeout) clearInterval(timeout);
    };
  }, [setHiddenButton]);

  /*
    useEffect(() => {
      setHiddenButton(hiddenButton)
    }, [hiddenButton]) 
  */

  return {
    theme,
    modalTelemedicinaHome,
    hiddenButton,
    cacheAgendamento,
    validaFilaAtendimento,
  };
};

export default useModelButtonTelemedicina;
